var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-toast',{attrs:{"title":"Atención","visible":_vm.active,"ok-only":"","variant":_vm.type},on:{"ok":_vm.closeModal}},[_vm._v(" "+_vm._s(_vm.message)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }